import { useEffect, useState } from "react";
import { api, peso } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

const TYPES = ["illegal_parking","wrong_slot","overstay","unauthorized","expired_parking"];

export default function Violations() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ violation_type: "illegal_parking", plate_number: "", description: "", penalty: 200 });

  const load = () => api.get("/violations").then(r => setList(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/violations", {
        ...form, plate_number: form.plate_number.toUpperCase(),
        penalty: Number(form.penalty) || 0,
        property_id: user.property_id,
      });
      toast.success("Violation reported");
      setForm({ violation_type: "illegal_parking", plate_number: "", description: "", penalty: 200 });
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  return (
    <div className="space-y-6">
      <header>
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500">Violations</p>
        <h1 className="font-heading text-4xl font-black tracking-tighter mt-1">Incidents.</h1>
      </header>
      <Card className="bg-[#141414] border-zinc-800 p-6">
        <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
          <div>
            <Label className="text-xs font-mono uppercase tracking-widest text-zinc-500">Type</Label>
            <Select value={form.violation_type} onValueChange={(v) => setForm({ ...form, violation_type: v })}>
              <SelectTrigger className="bg-[#0F0F10] border-zinc-800"><SelectValue /></SelectTrigger>
              <SelectContent>{TYPES.map(t => <SelectItem key={t} value={t}>{t.replace(/_/g," ")}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs font-mono uppercase tracking-widest text-zinc-500">Plate</Label>
            <Input value={form.plate_number} onChange={(e) => setForm({ ...form, plate_number: e.target.value.toUpperCase() })} className="bg-[#0F0F10] border-zinc-800 font-mono" />
          </div>
          <div className="md:col-span-2">
            <Label className="text-xs font-mono uppercase tracking-widest text-zinc-500">Description</Label>
            <Input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="bg-[#0F0F10] border-zinc-800" />
          </div>
          <div className="flex gap-2 items-end">
            <div className="flex-1">
              <Label className="text-xs font-mono uppercase tracking-widest text-zinc-500">Penalty</Label>
              <Input type="number" value={form.penalty} onChange={(e) => setForm({ ...form, penalty: e.target.value })} className="bg-[#0F0F10] border-zinc-800 font-mono" />
            </div>
            <Button type="submit" className="bg-orange-500 text-black hover:bg-orange-400" data-testid="violation-add-button">Report</Button>
          </div>
        </form>
      </Card>
      <Card className="bg-[#141414] border-zinc-800 p-6 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-zinc-500 text-xs font-mono uppercase">
            <th className="py-2 pr-4">When</th><th className="py-2 pr-4">Type</th>
            <th className="py-2 pr-4">Plate</th><th className="py-2 pr-4">Description</th>
            <th className="py-2 pr-4">Penalty</th><th className="py-2 pr-4">Status</th>
          </tr></thead>
          <tbody className="divide-y divide-zinc-800">
            {list.map(v => (
              <tr key={v.id}>
                <td className="py-2 pr-4 text-zinc-400 text-xs">{new Date(v.created_at).toLocaleString()}</td>
                <td className="py-2 pr-4 capitalize">{v.violation_type.replace(/_/g," ")}</td>
                <td className="py-2 pr-4 font-mono">{v.plate_number || "—"}</td>
                <td className="py-2 pr-4 text-zinc-300">{v.description}</td>
                <td className="py-2 pr-4 font-mono">{peso(v.penalty)}</td>
                <td className="py-2 pr-4">
                  <span className="inline-block px-2 py-0.5 text-xs rounded bg-orange-500/15 text-orange-300 border border-orange-500/30">{v.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
